import React, { useState } from 'react';
import { Calendar, Trash2, Phone, Mail, Edit } from 'lucide-react';

const UserCard = ({ user }) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="font-semibold text-[#1D2035]">{user.name}</h3>
          <p className="text-xs text-gray-400">{user.date}</p>
        </div>
        <button className="p-2 rounded-lg hover:bg-gray-100">
          <Trash2 size={18} className="text-gray-500" />
        </button>
      </div>
      <div className="space-y-2 text-sm">
        <div className="flex items-center gap-2">
          <Phone size={14} className="text-gray-400" />
          <span className="text-gray-700">{user.phone}</span>
        </div>
        <div className="flex items-center gap-2">
          <Mail size={14} className="text-gray-400" />
          <p className="text-gray-700 leading-relaxed">{user.emailPreview}</p>
        </div>
      </div>
      <button className="w-full mt-auto px-4 py-2.5 text-sm rounded-lg text-white bg-[var(--Primary-Primary)] flex items-center justify-center gap-2">
        <Edit size={16} /> فتح التذكرة
      </button>
    </div>
  );
};

export default function SupportPage() {
  const dir = "rtl";
  const [dateRange] = useState({ from: "يناير 2025", to: "يونيو 2025" });

  const users = [
    { name: "عصام سويلم", date: "2025/09/11 ت 04:16 م", phone: "+201118000533", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "أحمد عبد العظيم", date: "2025/09/11 ت 04:16 م", phone: "+20111089003", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "أشرف حسن", date: "2025/09/11 ت 04:16 م", phone: "+20111295586", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "مروان نشأت", date: "2025/09/11 ت 04:16 م", phone: "+201002632820", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "أسامة فرحات", date: "2025/09/11 ت 04:16 م", phone: "+201006224168", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "ماجد العطار", date: "2025/09/11 ت 04:16 م", phone: "+201007993959", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "عمار عبد الحليم", date: "2025/09/11 ت 04:16 م", phone: "+201005521587", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "معتز عبد العليم", date: "2025/09/12 ت 05:30 م", phone: "+201289188995", emailPreview: "مرحبا، اود الاستفسار عن معلومات إضافية..." },
    { name: "أسامة يونس", date: "2025/09/11 ت 04:16 م", phone: "+201000534760", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "صابر عبد الحميد", date: "2025/09/11 ت 04:16 م", phone: "+201000239271", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "عصام طلبه", date: "2025/09/11 ت 04:16 م", phone: "+201002266050", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
    { name: "وائل غريب", date: "2025/09/13 ت 06:45 م", phone: "+201005705576", emailPreview: "مرحبا احتاج الى مساعدتكم في الغاء حجز..." },
  ];

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir={dir}>
      {/* Header */}
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold text-[#1D2035] mb-1">إدارة المستخدمين</h1>
          <div className="flex items-center gap-2 md:gap-3">
            <button className="px-4 py-2.5 rounded-lg text-white bg-[var(--Primary-Primary)] shadow-sm text-sm md:text-base">
              إضافة مستخدم جديد
            </button>
            <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
              <span className="inline-block transform -scale-y-100">↑↓</span>
              من الاحدث الى الاقدم
            </button>
            <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
              <Calendar size={16} className="text-gray-500" />
              {dateRange.from} - {dateRange.to}
            </button>
          </div>
        </div>
        <div className="text-right">
          <div className="text-sm text-gray-500">إجمالي المستخدمين</div>
          <div className="text-3xl md:text-4xl font-bold text-[#1D2035]">17,370</div>
        </div>
      </div>

      {/* Users Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {users.map((user, index) => (
          <UserCard key={index} user={user} />
        ))}
      </div>
    </div>
  );
}
